<template>
  <div>
    <div
      style="width:100%; background-color:#FFFFFF; text-align:left; padding:10px; border-radius: 3px;"
    >
      <h4>ホストバンド</h4>

      <li
        class="text-base"
        v-for="(item,index) in fromiineList"
        :key="index"
        style="list-style: none;"
      >
        <a class="item-image pr-2">
          <img
            class="m-1"
            :src="item.image"
            width="40"
            height="40"
            v-b-modal="artistInfoId3(index)"
          />
          <!-- Modal Component -->
          <b-modal hide-footer :id="'artistInfo3' + index ">
            <img class="m-1" :src="item.image" width="100" height="100" />
            <h1>{{item.name}}</h1>
            <div>
              <a
                v-if="item.twitter"
                v-bind:href="'https://twitter.com/' + item.twitter"
                class="btn btn-neutral btn-icon-only btn-twitter btn-round btn-sm"
                data-toggle="tooltip"
                data-original-title="Follow us"
              >
                <i class="fa fa-twitter"></i>
              </a>

              <a
                v-if="item.facebook"
                v-bind:href="'https://facebook.com/' + item.facebook"
                class="btn btn-neutral btn-icon-only btn-facebook btn-round btn-sm"
                data-toggle="tooltip"
                data-original-title="Follow us"
              >
                <i class="fa fa-facebook"></i>
              </a>

              <a
                v-if="item.instagram"
                v-bind:href="'https://instagram.com/' + item.instagram"
                class="btn btn-neutral btn-icon-only btn-instagram btn-round btn-sm"
                data-toggle="tooltip"
                data-original-title="Follow us"
              >
                <i class="fa fa-instagram"></i>
              </a>
            </div>
            <div class="mt-2">{{item.pr}}</div>
          </b-modal>
        </a>
        <B>{{item.name}}</B>
      </li>
    </div>
  </div>
</template>
<script>
import firebase from "firebase/app";

export default {
  name: "fromIineList",
  data() {
    return {
      fromiineList: [],
      iine: 0,
      hostlist: [
        "t2xkI2CwWZZZeQEDs09HjXovL0v2",
        "RIC3DRViwXaOqc8e0zhqLvArWkM2",
        "Bk8H0nh2W9gy5vl5AcZv6Ej5jsX2",
        "8J99aarTaRPHXjUOj9iK2aBGv3X2",
        "G5KcuI4VMWexkFwaZsT0hFrNN0f2",
        "xQBM49gteSTou6nkvupKUcgjTvD2",
        "Fh15d2u977R0bIoQpb0ZNiXQ4Cm1",
        "1gigqUuB7FQ2L5TGWetMPRqoxM62"
      ]
    };
  },
  computed: {
    nowJoinSessionInfo() {
      return this.$store.state.nowJoinSessionInfo;
    }
  },
  created() {
    //認証
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.fromiinelisten();
      } else {
        this.$router.push("/");
      }
    });
    //認証

    firebase
      .database()
      .ref("loginuser/")
      .on("value", snapshot => {
        this.fromiinelisten();
      });
  },
  methods: {
    artistInfoId3(index) {
      return "artistInfo3" + index;
    },
    fromiinelisten() {
      var list = this.hostlist;
      var iinelist = [];

      for (var i = 0; i < list.length; i++) {
        firebase
          .database()
          .ref("loginuser/" + list[i])
          .on("value", snapshot => {
            iinelist.push(snapshot.val());
          });
      }
      this.fromiineList = iinelist;
    }
  }
};
</script>


<style>
.item-image img {
  border-radius: 50%;
  vertical-align: top;
  border: solid 2px rgb(245, 245, 232);
}
</style>